import { useEffect } from 'react';

import useInsuranceModuleStorage from './hooks/useInsuranceModuleStorage';

const InitialInsuranceModules: React.FunctionComponent = () => {
  const { fillInsuranceModulesState } = useInsuranceModuleStorage();

  useEffect(() => {
    fillInsuranceModulesState();
  }, []);

  return <></>;
};

export default InitialInsuranceModules;
